export default "__VITE_ASSET__55350eae__"